@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

.title-wrapper {
  display: inline;
}

.title {
  position: relative;
  font-size: 48px;
  font-family: Avenir, Montserrat, Prompt, serif;
  font-weight: 500;
  display: flex;
  line-height: 48px;
  margin: 0;
  font-style: normal;
  justify-content: flex-start;
  color: #fff;
  white-space: pre-line;

  @media (max-width: map.get($grid-breakpoints, md)) {
    font-size: 28px;
    line-height: 2.4rem;
  }

  &--inline {
    display: inline;
  }

  &--black {
    color: black;
  }

  &--h1-entry {
    font-size: 7.5rem;
    line-height: 7.5rem;

    @media (max-width: map.get($grid-breakpoints, xl)) {
      margin: 0 0.8rem;
      font-size: 4.375rem;
      line-height: 4.375rem;
    }
  }

  &--h1-alternate {
    margin: 3rem 0;
    font-size: 3rem;
    line-height: 3.75rem;
    letter-spacing: 0.02em;

    @media (max-width: map.get($grid-breakpoints, md)) {
      line-height: 3rem;
      margin: 0;
      font-size: 28px;
    }
  }

  &--h2 {
    font-family: Avenir, Montserrat, Prompt, serif;
    font-size: 2.25rem;
    font-weight: 700;
    line-height: 3.375rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-weight: 600;
      font-size: 1.125rem;
      line-height: 1.6rem;
    }
  }

  &--h2-alternate {
    font-family: Avenir, Montserrat, Prompt, serif;
    font-size: 2.25rem;
    font-weight: 700;
    line-height: 3.375rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-weight: 600;
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }

  &--h3 {
    font-size: 2rem;
    font-weight: 500;
    line-height: 3rem;
    text-align: left;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-size: 1rem;
      line-height: 1.25rem;
    }
  }

  &--h3-entry {
    font-family: Avenir, Montserrat, Poppins, serif;
    font-size: 2.25rem;
    font-weight: 600;
    line-height: 3.375rem;
  }

  &--h4 {
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 2.25rem;
    text-align: left;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-size: 1rem;
      line-height: 1.25rem;
    }
  }
}

.info {
  position: relative;
  top: -0.5rem;
  display: inline;
  color: #fff;
  font-size: 2rem;
  margin-left: 1.18rem;

  @media (max-width: map.get($grid-breakpoints, md)) {
    visibility: hidden;
  }
}

.subtitle {
  font-size: 1.5rem;
  font-family: Avenir, Montserrat, Poppins, serif;
  font-weight: 400;
  line-height: 2.25;
  text-align: left;
  display: flex;
  margin: 0;
  font-style: normal;
  justify-content: center;
  color: #fffaf1;

  @media (max-width: map.get($grid-breakpoints, md)) {
    font-size: 1rem;
  }
}
